module.exports = __webpack_public_path__ + "img/kp.526d9fce.svg";